export const PAGE_HEADER_PADDING = 24;
export const PAGE_SIZE_IN_BACKEND = 20;
export const CONTENT_HEADER_HEIGHT = 80;

export const TABLE_CODE_WIDTH = 80;
export const TABLE_TREE_CODE_WIDTH = 136;
export const TABLE_LONG_CODE_WIDTH = 180;
export const TABLE_YEAR_WIDTH = 120;
export const TABLE_DATE_WIDTH = 120;
export const TABLE_DATETIME_WIDTH = 180;
export const TABLE_MONETARY_AMOUNT_WIDTH = 140;
export const TABLE_BUTTON_WIDTH = 80;
export const TABLE_SINGLE_ICON_WIDTH = 30;
export const TABLE_DOUBLE_ICONS_WIDTH = 60;
export const TABLE_ROW_MENU_WIDTH = 140;
export const TABLE_ROW_MENU_WIDTH_WITH_LINK = 180;
// コメントのオーバレイ以下にならないように注意
export const Z_INDEX_CONTENT_HEADER = 20;
export const Z_INDEX_CONTENT_FOOTER = 10;
export const Z_INDEX_GLOBAL_SIDEBAR = 20;
// 検証環境バナーは Modal / Drawer（antd の既定は 1000）より前面に出す
export const Z_INDEX_TARGET_ENV_BANNER = 1100;
export const PAGE_LAYOUT_MIN_WIDTH = 920;
export const PAGE_LAYOUT_SIDEBAR_WIDTH_COLLAPSED = 80;
export const PAGE_LAYOUT_SIDEBAR_WIDTH = 200;
export const MODAL_FORM_WIDTH = 1340;
export const MODAL_WIDTH = 480;
export const CSV_LINE_BREAK = '\r\n';
export const CSV_BOM = new Uint8Array([0xef, 0xbb, 0xbf]);

export const DIFF_DEFAULT_FONT_SIZE = '13px';

export const PAGE_CONTENT_PADDING = 24;

export const DEFAULT_FONT_FAMILY = 'Noto Sans JP';
export const PUBLIC_SITE_FONT_FAMILY = "'BIZ UDPGothic', sans-serif";

const QUINTILLION = 1_000_000_000_000_000;
const QUADRILLION = 1_000_000_000_000;
export const PRICE_INPUT_MAX_VALUE = QUINTILLION - 1;
export const NUMBER_INPUT_MAX_VALUE = QUADRILLION - 1;

export const NEST_ITEM_CONNECTOR = ' / ';
export const ITEM_SPLITTER = ' | ';
export const ITEM_SPLITTER_COMMA = ', ';

export const FALLBACK_TEXT = '--';
export const SPACE_TEXT = ' ';
export const NEW_LINE_TEXT = '\n';

export const HEADER_ID_FOR_OFFSET_HEIGHT = 'page-header-for-offset-height';
export const PS_HEADER_ID_FOR_OFFSET_HEIGHT =
  'ps-page-header-for-offset-height';

/** @description Antd uses 24 as a constant for grid columns */
export const ANTD_GRID_COLUMNS = 24;

export const FORMULA_MAX_LENGTH = 255;
export const FORMULA_RESULT_MAX_VALUE = BigInt('9223372036854775807');
